exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tct-semaphore{width:100%;height:12px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:distribute;justify-content:space-around;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.tct-semaphore__circle{border-radius:50%;min-width:12px;min-height:12px;background-color:#fff}.tct-semaphore__circle+.tct-semaphore__circle{margin-left:5px}.tct-semaphore .status-0.active{background-color:red}.tct-semaphore .status-1.active{background-color:#f4d517}.tct-semaphore .status-2.active{background-color:#20d91d}", ""]);

// exports
